<button
  type="button"
  class="login-modal__backdrop"
  aria-hidden="true"
  tabindex="-1"
  (click)="close()"
></button>

<section
  class="login-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="login-modal-title"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  <header class="login-modal__header">
    <div class="login-modal__brand">
      <img class="login-modal__brand-logo" [src]="session.currentTheme() === 'dark' ? brand.logoOnDark : brand.logo" [alt]="brand.name" />
      <h2 id="login-modal-title" class="login-modal__title">{{ 'auth.modal.title' | translate }}</h2>
    </div>

    <button
      type="button"
      class="login-modal__close"
      [attr.aria-label]="'auth.modal.close' | translate"
      (click)="close()"
    >
      <span class="material-symbols-outlined login-modal__close-icon" aria-hidden="true">close</span>
    </button>
  </header>

  <form class="login-modal__form" [formGroup]="form" [attr.aria-busy]="isSubmitting()" (ngSubmit)="submit()">
    <div class="login-modal__field">
      <label class="login-modal__label" for="login-username">{{ 'auth.modal.username' | translate }}</label>
      <input
        id="login-username"
        class="login-modal__input"
        type="text"
        cdkFocusInitial
        required
        formControlName="username"
        [attr.placeholder]="'auth.modal.usernamePlaceholder' | translate"
        autocomplete="username"
        enterkeyhint="go"
      />
    </div>

    <div class="login-modal__field login-modal__field--password">
      <label class="login-modal__label" for="login-password">{{ 'auth.modal.password' | translate }}</label>
      <input
        id="login-password"
        class="login-modal__input"
        type="password"
        required
        formControlName="password"
        placeholder="••••••••"
        autocomplete="current-password"
        enterkeyhint="go"
      />
      <button
        type="button"
        class="login-modal__meta-action login-modal__meta-action--forgot"
        (click)="ignoreAuxiliaryAction($event)"
      >
        {{ 'auth.modal.forgotPassword' | translate }}
      </button>
    </div>

    <button
      type="submit"
      class="login-modal__submit"
      [disabled]="form.invalid || isSubmitting()"
    >
      {{ 'auth.modal.submit' | translate }}
    </button>
  </form>

  <p class="login-modal__footer">
    <span>{{ 'auth.modal.newToBrand' | translate: { brand: brand.name } }}</span>
    <button
      type="button"
      class="login-modal__meta-action login-modal__meta-action--footer"
      (click)="ignoreAuxiliaryAction($event)"
    >
      {{ 'auth.modal.createAccount' | translate }}
    </button>
  </p>
</section>
